var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('referrals-view',{attrs:{"loading":_vm.loading,"user-referrings":_vm.userReferrings,"user-referrer-percent":_vm.userReferrerPercent,"enable-scroll":_vm.enableScroll},on:{"next":_vm.scrollHandler}})}
var staticRenderFns = []

export { render, staticRenderFns }